import produce from 'immer';
import { GET_SUPER_ADMIN_DASHBOARD_SUCCESS, GET_Graph_DASHBOARD_SUCCESS } from './constants';

const INITIAL_STATE = {
    dashboardData: [],
    graphData: []
};

const superAdminDashboard = produce((draft, action) => {
    switch (action?.type) {
        case GET_SUPER_ADMIN_DASHBOARD_SUCCESS:
            draft.dashboardData = action.payload;
            break;
        case GET_Graph_DASHBOARD_SUCCESS:
            draft.graphData = action.payload;
            break;

        default:
    }
}, INITIAL_STATE);

export default superAdminDashboard;
